import { z } from 'zod';
import { Team } from '../referralFormSchema';

export const FieldEnum = {
  team: 'team',
};

export type TeamType = z.infer<typeof Team>;
